import { ModelDataChangeCompanyFilter, ModelDataChangeFilterRegistry } from "@mcleod/components";
import { ModelDataChangeFilterInitializer } from "@mcleod/common";

export class ImagingModelDataChangeFilterInitializer extends ModelDataChangeFilterInitializer {
    public initialize() {
        super.initialize();
        ModelDataChangeFilterRegistry.get().register(new ModelDataChangeCompanyFilter());
    }
}
